import { Banner } from './Banner';
import drerykBanner from './resources/drerykBanner';

export const DrErykStaticBanner = (): JSX.Element => {
   return (
      <Banner
         testId={'dreryk-news-static-banner'}
         bannerUrl={drerykBanner}
         targetUrl={'https://dreryk.pl/o-nas/aktualnosci/'}
      />
   );
};
